import axiosInstance from "axios";

const axios = axiosInstance.create({
  baseURL: "https://app.cuc.edu.co:4000"
  /* baseURL:"http://localhost:4000" */
});

export default axios;
